module.exports = __webpack_public_path__ + "static/img/bdc-kpi-target.dbe586b3.svg";